import type { TFunction } from 'i18next'
import type {
  ExtractionProgressStep,
  ExtractionProgressStepStatus,
} from '@/components/extraction-progress-checklist'
import {
  MACHINE_CHARACTERISTICS_EXTRACTION_SECTION_KEYS,
  type MachineCharacteristicsExtractionSectionKey,
  type MachineCharacteristicsExtractionSectionStatus,
  type MachineCharacteristicsExtractionTaskState,
} from './machineCharacteristicsExtractionTaskState'

const SECTION_I18N_KEY: Record<MachineCharacteristicsExtractionSectionKey, string> = {
  intended_use: 'intendedUse',
  machine_form_sector: 'machineFormSector',
  permanent_access: 'permanentAccess',
  people_at_machine: 'peopleAtMachine',
  energy_and_drives: 'energyAndDrives',
  operator_demands: 'operatorDemands',
  body_openings: 'bodyOpenings',
  health_environment: 'healthEnvironment',
  safeguarding: 'safeguarding',
  control_indication: 'controlIndication',
}

function mapSectionStatus(
  status: MachineCharacteristicsExtractionSectionStatus
): ExtractionProgressStepStatus {
  if (status === 'pending') {
    return 'pending'
  }
  if (status === 'active') {
    return 'active'
  }
  if (status === 'done' || status === 'skipped') {
    return 'done'
  }
  return 'pending'
}

export function buildMachineCharacteristicsExtractionSteps(
  state: MachineCharacteristicsExtractionTaskState,
  translate: TFunction<'machineryDirectiveCompliance', undefined>
): ExtractionProgressStep[] {
  const steps: ExtractionProgressStep[] = []

  for (const sectionKey of MACHINE_CHARACTERISTICS_EXTRACTION_SECTION_KEYS) {
    const sectionStatus = state.sections[sectionKey]
    const subtitle =
      sectionStatus === 'skipped'
        ? translate('onboarding.machineCharacteristicsExtraction.skippedSection')
        : undefined
    steps.push({
      id: sectionKey,
      title: translate(
        `onboarding.machineCharacteristicsExtraction.sections.${SECTION_I18N_KEY[sectionKey]}`
      ),
      subtitle,
      status: mapSectionStatus(sectionStatus),
    })
  }

  return steps
}
